$(document).ready(function () {
  $(".custom-video").slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  if ($(window).width() > 1366) {
    $(
      ".site-header .header-item--navigation > .site-navigation > li:nth-child(1)"
    ).hoverIntent({
      over: showNav,
      out: hideNav,
      timeout: 40,
    });
    $(".shop-by-concern-menu").hoverIntent(showNav, hideNav);
    function showNav(e) {
      $(".shop-by-concern-menu").addClass("active");
      if ($(window).width() < 1366) {
        if ($(".shop-by-concern-menu").hasClass("active")) {
          $("body").css("overflow", "hidden");
        }
      }
    }

    function hideNav(e) {
      $(".shop-by-concern-menu").removeClass("active");
      $("body").css("overflow", "auto");
    }
  }
  if ($(window).width() > 768 && $(window).width() < 1400) {
    $(
      ".site-header .header-item--navigation > .site-navigation > li:nth-child(1)"
    ).hover(showNav, hideNav);
    $(".shop-by-concern-menu").hover(showNav, hideNav);
    function showNav(e) {
      $(".shop-by-concern-menu").addClass("active");
      if ($(window).width() < 1366) {
        if ($(".shop-by-concern-menu").hasClass("active")) {
          $("body").css("overflow", "hidden");
        }
      }
    }

    function hideNav(e) {
      $(".shop-by-concern-menu").removeClass("active");
      $("body").css("overflow", "auto");
    }
  }

  $("body:not('.new-pdp') .mobile-nav > li:nth-child(1)").click(function (e) {
    e.preventDefault();
    $(".drawer--right").removeClass("drawer--is-open");
    $("html").removeClass("js-drawer-open");
    $("#HeaderWrapper").addClass("overflow-auto");
    $("body,html").addClass("overflow-hidden");
    // $('#HeaderWrapper .site-header').addClass('hide-main-nav');
    $(".shop-by-concern-menu").addClass("active");
  });
  $(".close-icon").click(function () {
    $("#HeaderWrapper .site-header").removeClass("hide-main-nav");
    $(".shop-by-concern-menu").removeClass("active");
    // $('#HeaderWrapper').removeClass('overflow-auto');
    $("body,html").removeClass("overflow-hidden");
  });
  $(".shop-by-concern-menu-grid-item").click(function () {
    if ($(this).hasClass("slide-down")) {
      $(this).removeClass("slide-down");
      return false;
    }
    $(".shop-by-concern-menu-grid-item").removeClass("slide-down");
    $(this).toggleClass("slide-down");
  });

  $(".variant-btn").click(function () {
    $(".product-block--price .save-div").removeClass("show");
    var VariantId = $(this).attr("data-variation-id");
    $("#" + VariantId).addClass("show");
  });
});
